import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _assertThisInitialized from '@babel/runtime/helpers/esm/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import 'pp-vx/dist/components/modal/modal.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { FocusOn } from 'react-focus-on';
import clsx from 'clsx';

var uniqueId = function () {
  return (Math.random() * 100000000).toFixed(0).toString();
};

var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "closeButton", void 0);

    _defineProperty(_assertThisInitialized(_this), "shouldSetFocus", false);

    _defineProperty(_assertThisInitialized(_this), "idBase", void 0);

    _this.closeButton = React.createRef();
    _this.idBase = props.id || uniqueId();
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;

      // Skip this if rendering server-side
      if (window && window.setTimeout) {
        // HACK ALERT! react-on-focus fails at setting the focus
        // if we are transitioning opacity. This causes the lightbox
        // to set the focus on the close button but NOT indicate
        // that fact to the user either visually or in the screen reader
        // So I had to handle that case on a timeout --love, BCC
        if (this.shouldSetFocus && this.props.isOpen && this.closeButton.current) {
          // Store the close button as a local for the closure
          var closeButton = this.closeButton.current;
          window.setTimeout(function () {
            closeButton.focus();
            _this2.shouldSetFocus = false;
          }, 100);
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // We need to set the focus ONLY when the next state
      // is open and the current state is not.
      if (nextProps.isOpen && !this.props.isOpen) {
        this.shouldSetFocus = true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onClose = _this$props.onClose,
          className = _this$props.className,
          isOpen = _this$props.isOpen,
          hideLogo = _this$props.hideLogo,
          title = _this$props.title,
          _this$props$closeOnBa = _this$props.closeOnBackgroundClick,
          closeOnBackgroundClick = _this$props$closeOnBa === void 0 ? true : _this$props$closeOnBa,
          _this$props$action = _this$props.action,
          action = _this$props$action === void 0 ? null : _this$props$action,
          overpanel = _this$props.overpanel,
          center = _this$props.center,
          rest = _objectWithoutProperties(_this$props, ["children", "onClose", "className", "isOpen", "hideLogo", "title", "closeOnBackgroundClick", "action", "overpanel", "center"]);

      var wrapperClasses = clsx('ppvx_modal-backdrop', className);
      var classes = clsx('ppvx_modal', {
        'ppvx_modal--overpanel': overpanel
      });
      var contentClasses = clsx('ppvx_modal__contents', {
        'ppvx_modal__contents--center': center
      });
      var ariaHidden = isOpen === true ? 'false' : 'true';
      var closeButton = React.createElement("button", {
        className: "ppvx_modal-header__close-btn",
        "aria-label": "close modal",
        "aria-haspopup": "dialog",
        tabIndex: 0,
        onClick: onClose,
        ref: this.closeButton
      });

      var handleEscape = function (evt) {
        if (onClose) {
          evt.preventDefault();
          onClose(evt);
        }
      };

      var handleBackdropClick = function (evt) {
        if (closeOnBackgroundClick && onClose) {
          onClose(evt);
        }
      };

      var titleId = "header_".concat(this.idBase);
      var contents = React.createElement("div", {
        className: wrapperClasses,
        role: "dialog",
        "aria-labelledby": titleId,
        "aria-modal": "true",
        "aria-hidden": ariaHidden
      }, React.createElement(FocusOn, {
        enabled: !!isOpen // @ts-ignore: onEscapeKey() wants an Event, but the rest of this code wants SyntheticEvent<>
        ,
        onEscapeKey: function onEscapeKey(evt) {
          return handleEscape(evt);
        },
        onClickOutside: function onClickOutside() {
          return handleBackdropClick();
        }
      }, React.createElement("article", _extends({
        className: classes
      }, rest), React.createElement("header", {
        className: clsx('ppvx_modal-header', {
          'ppvx_modal-header--no-logo': hideLogo
        })
      }, React.createElement("div", {
        className: "ppvx_modal-header__action"
      }, action), React.createElement("div", {
        className: "ppvx_modal-header__close"
      }, closeButton)), React.createElement("section", {
        className: contentClasses
      }, React.createElement("h2", {
        id: titleId
      }, title), children))));
      return ReactDOM.createPortal(contents, document.body);
    }
  }]);

  return Modal;
}(React.Component);

export { Modal };
